import {getExampleNumber as getLibPhoneNumberExample} from 'libphonenumber-js';
import examples from 'libphonenumber-js/mobile/examples';
import type {PhoneNumberCountryCode} from '../PhoneNumberFieldConfig';

/**
 * Gets a formatted example number without its country calling code.
 */
export function getPhoneNumberExampleForCountry(
  country: PhoneNumberCountryCode,
): string | undefined {
  const phoneNumber = getLibPhoneNumberExample(country, examples);
  if (!phoneNumber) {
    return undefined;
  }

  if (phoneNumber.country === 'US' || phoneNumber.country === 'CA') {
    return phoneNumber.formatNational();
  }

  return phoneNumber
    .formatInternational()
    .replace(/^\+\d*/, '')
    .trim();
}
